import React from 'react';
import Homepage from '../Homepage';
import Login from '../login';
import Register from '../register';

// PUBLIC PAGES
import HowItWorks from '../public-pages/how-it-works';
import Referrals from '../public-pages/referrals';
import Terms from '../public-pages/terms';
import PrivacyPolicy from '../public-pages/privacy-policy';
import Logos from '../public-pages/logos';
import Followers from '../public-pages/followers';
import PaymentDetails from '../public-pages/payment-details';
import MyReferrals from '../public-pages/my-referrals';
import Following from '../public-pages/following';
import VerificationPage from '../public-pages/verify/index';
import MyNotification from '../public-pages/my-notification';
import PasswordReset from '../public-pages/password/reset';
import SocialMediaInfluencer from '../public-pages/social-media-influencer';
import Trial from '../public-pages/trial';

// PRIVATE PAGES - user needs to login
import EditProfile from '../private-pages/edit-profile';
import AddAccount from '../private-pages/add-account';
import BecomeCreator from '../private-pages/become-creator';
import CreatePost from '../private-pages/create';
import Profile from '../private-pages/profile';
import Messages from '../private-pages/messages';
import IndividualMessage from '../private-pages/messages/IndividualMessage';
import Promotion from '../private-pages/promotion';
import Performance from '../private-pages/performance';
import AdvancedSettings from '../private-pages/settings';
import CreatorAdvancedSettings from '../private-pages/creator-settings';
import WelcomeMessages from '../private-pages/welcome-messages';
import UserLists from '../private-pages/user-lists';

// Admin pages
import AdminIndex from '../admin-pages';
import Dashboard from '../admin-pages/dashboard';
import Users from '../admin-pages/users';
import PuEarningList from '../admin-pages/pu-earning-list/index';
import SubscriberPaymentHistory from '../admin-pages/subscriber-payment-history';
import ReferralsList from '../admin-pages/referrals-list';
import Transactions from '../admin-pages/transactions';
import PuPayout from '../admin-pages/pu-payout';
import EmailSusPromo from '../admin-pages/email-sus-promo';
import CleanupServerMedia from '../admin-pages/cleanup-server-media';
import SystemGlobalSettings from '../admin-pages/system-global-settings';
import SuggestedCreators from '../admin-pages/suggested-creators';
import ImportWelcomeMessages from '../admin-pages/import-welcome-messages';
import ExchangeRate from '../admin-pages/exchange-rate';
import DownloadPostMedias from '../admin-pages/download-post-medias';
import DownloadStashMedias from '../admin-pages/download-stash-medias';
// import ReportedPosts from '../admin-pages/reported-posts';
import ScheduledPostsCron from '../admin-pages/crons/ScheduledPosts';
import MailNotificationsCron from '../admin-pages/crons/MailNotifications';
import PriceChangesCron from '../admin-pages/crons/PriceChanges';
import PauseListsCron from '../admin-pages/crons/PauseLists';
// import MassMailsCron from '../admin-pages/crons/MassMails'
// import MediasOrientationCron from '../admin-pages/crons/MediasOrientation'
import CreatorSalesBoost from '../admin-pages/creator-sales-boost';
import EditFollowers from '../admin-pages/edit-followers';
import TermsForm from '../admin-pages/terms-form';
import PrivacyPolicyForm from '../admin-pages/privacy-policy-form';
import CreatorSalesBoostRefund from '../admin-pages/creator-sales-boost-refund';
import FollowerSubIndex from '../admin-pages/follower-sub-index';
import PageNotFound from '../public-pages/404';
import NewMessage from '../private-pages/messages/NewMessage';

export const adminRoutes = [
    {
        path: '/administration',
        exact: true,
        name: '',
        component: () => <AdminIndex />,
    },
    {
        path: '/administration/dashboard',
        exact: true,
        name: 'dashboard',
        component: () => <Dashboard />,
    },
    {
        path: '/administration/users',
        exact: true,
        name: 'users',
        component: () => <Users />,
    },
    {
        path: '/administration/pu-earnings',
        exact: true,
        name: 'pu-earnings',
        component: () => <PuEarningList />,
    },
    {
        path: '/administration/subscriber-payment-history',
        exact: true,
        name: 'subscriber-payment-history',
        component: () => <SubscriberPaymentHistory />,
    },
    {
        path: '/administration/referrals-list',
        exact: true,
        name: 'referrals-list',
        component: () => <ReferralsList />,
    },
    {
        path: '/administration/suggested-creators',
        exact: true,
        name: 'suggested-creators',
        component: () => <SuggestedCreators />,
    },
    {
        path: '/administration/transactions',
        exact: true,
        name: 'transactions',
        component: () => <Transactions />,
    },
    {
        path: '/administration/pu-payout',
        exact: true,
        name: 'pu-payout',
        component: () => <PuPayout />,
    },
    {
        path: '/administration/email-sus-promo',
        exact: true,
        name: 'email-sus-promo',
        component: () => <EmailSusPromo />,
    },
    {
        path: '/administration/import-welcome-messages',
        exact: true,
        name: 'import-welcome-messages',
        component: () => <ImportWelcomeMessages />,
    },
    {
        path: '/administration/exchange-rate',
        exact: true,
        name: 'exchange-rate',
        component: () => <ExchangeRate />,
    },
    {
        path: '/administration/cleanup-server-media',
        exact: true,
        name: 'cleanup-server-media',
        component: () => <CleanupServerMedia />,
    },
    {
        path: '/administration/system-global-settings',
        exact: true,
        name: 'system-global-settings',
        component: () => <SystemGlobalSettings />,
    },
    {
        path: '/administration/creator-sales-boost',
        exact: true,
        name: 'creator-sales-boost',
        component: () => <CreatorSalesBoost />,
    },
    {
        path: '/administration/creator-sales-boost-refund',
        exact: true,
        name: 'creator-sales-boost-refund',
        component: () => <CreatorSalesBoostRefund />,
    },
    {
        path: '/administration/edit-followers',
        exact: true,
        name: 'edit-followers',
        component: () => <EditFollowers />,
    },
    {
        path: '/administration/followers-sub-index',
        exact: true,
        name: 'followers-sub-index',
        component: () => <FollowerSubIndex />,
    },
    {
        path: '/administration/crons/scheduled-posts',
        exact: true,
        name: 'scheduled-posts',
        component: () => <ScheduledPostsCron />,
    },
    {
        path: '/administration/crons/mail-notifications',
        exact: true,
        name: 'mail-notifications',
        component: () => <MailNotificationsCron />,
    },
    {
        path: '/administration/crons/price-changes',
        exact: true,
        name: 'price-changes',
        component: () => <PriceChangesCron />,
    },
    {
        path: '/administration/crons/pause-lists',
        exact: true,
        name: 'pause-lists',
        component: () => <PauseListsCron />,
    },
    // {
    //   path: '/administration/crons/mass-mails',
    //   exact: true,
    //   name: 'mass-mails',
    //   component: () => <MassMailsCron />,
    // },
    // {
    //   path: '/administration/crons/medias-orientation',
    //   exact: true,
    //   name: 'medias-orientation',
    //   component: () => <MediasOrientationCron />,
    // },
    {
        path: '/administration/download-post-medias',
        exact: true,
        name: 'download-post-medias',
        component: () => <DownloadPostMedias />,
    },
    {
        path: '/administration/download-stash-medias',
        exact: true,
        name: 'download-stash-medias',
        component: () => <DownloadStashMedias />,
    },
    {
        path: '/administration/reported-posts',
        exact: true,
        name: 'reported-posts',
        component: () => <ReportedPosts />,
    },
    {
        path: '/administration/terms',
        exact: true,
        name: 'terms-form',
        component: () => <TermsForm />,
    },
    {
        path: '/administration/privacy-policy',
        exact: true,
        name: 'privacy-policy-form',
        component: () => <PrivacyPolicyForm />,
    }
];

export const privRoutes = [
    {
        path: '/trial/:promoUrl',
        exact: true,
        name: 'trial',
        component: () => <Trial />,
    },
    {
        path: '/followers',
        exact: true,
        name: 'followers',
        component: () => <Followers />,
    },
    {
        path: '/payment-details',
        exact: true,
        name: 'payment-details',
        component: () => <PaymentDetails />,
    },
    {
        path: '/following',
        exact: true,
        name: 'following',
        component: () => <Following />,
    },
    {
        path: '/promotion',
        exact: true,
        name: 'promotion',
        component: () => <Promotion />,
    },
    {
        path: '/',
        exact: true,
        name: 'homepage',
        component: () => <Homepage />,
    },
    {
        path: '/home',
        exact: true,
        name: 'home',
        component: () => <Homepage />,
    },
    {
        path: '/edit-profile',
        exact: true,
        name: 'edit-profile',
        component: () => <EditProfile />,
    },
    {
        path: '/settings',
        exact: true,
        name: 'settings',
        component: () => <AdvancedSettings />,
    },
    {
        path: '/creator-advanced-settings',
        exact: true,
        name: 'creator-advanced-settings',
        component: () => <CreatorAdvancedSettings />,
    },
    {
        path: '/messages',
        exact: true,
        name: 'messages',
        component: () => <Messages />,
    },
    {
        path: '/messages/newmessage',
        exact: true,
        name: 'messages-newmessage',
        component: () => <NewMessage />,
    },
    {
        path: '/messages/:id',
        exact: true,
        name: 'individual-message',
        component: () => <IndividualMessage />,
    },
    {
        path: '/become-creator',
        exact: true,
        name: 'become-creator',
        component: () => <BecomeCreator />,
    },
    {
        path: '/create',
        exact: true,
        name: 'create',
        component: () => <CreatePost />,
    },
    {
        path: '/my-referrals',
        exact: true,
        name: 'my-referrals',
        component: () => <MyReferrals />,
    },
    {
        path: '/add-account',
        exact: true,
        name: 'add-account',
        component: () => <AddAccount />,
    },
    {
        path: '/performance',
        exact: true,
        name: 'performance',
        component: () => <Performance />,
    },
    {
        path: '/welcome-messages',
        exact: true,
        name: 'welcome-messages',
        component: () => <WelcomeMessages />,
    },
    {
        path: '/user-lists',
        exact: true,
        name: 'user-lists',
        component: () => <UserLists />,
    },
    {
        path: '/my-notification',
        exact: true,
        name: 'my-notification',
        component: () => <MyNotification />,
    },
    // Duplicated to be accessible from logged in users
    {
        path: '/terms',
        exact: true,
        name: 'terms',
        component: () => <Terms />,
    },
    {
        path: '/privacy-policy',
        exact: true,
        name: 'privacy-policy',
        component: () => <PrivacyPolicy />,
    },
];

export const pubRoutes = [
    {
        path: '/trial/:promoUrl',
        exact: true,
        name: 'trial',
        component: () => <Trial />,
    },
    {
        path: '/',
        exact: true,
        name: 'homepage',
        component: () => <Homepage />,
    },
    {
        path: '/login',
        exact: true,
        name: 'login',
        component: () => <Login />,
    },
    {
        path: '/register',
        exact: true,
        name: 'register',
        component: () => <Register />,
    },
    {
        path: '/how-it-works',
        exact: true,
        name: 'how-it-works',
        component: () => <HowItWorks />,
    },
    {
        path: '/referrals',
        exact: true,
        name: 'referrals',
        component: () => <Referrals />,
    },
    {
        path: '/terms',
        exact: true,
        name: 'terms',
        component: () => <Terms />,
    },
    {
        path: '/privacy-policy',
        exact: true,
        name: 'privacy-policy',
        component: () => <PrivacyPolicy />,
    },
    {
        path: '/logos',
        exact: true,
        name: 'logos',
        component: () => <Logos />,
    },
    {
        path: '/verify',
        exact: true,
        name: 'verify',
        component: () => <VerificationPage />,
    },
    {
        path: '/password/reset/:token',
        exact: true,
        name: 'reset',
        component: () => <PasswordReset />,
    },
    {
        path: '/social-media-influencer-creator-guide',
        exact: true,
        name: 'social-media-influencer',
        component: () => <SocialMediaInfluencer />,
    },
];

export const userRoutes = [
    {
        path: '/:username', // login
        exact: true,
        name: '',
        component: () => <Profile />,
    },
];

export const errorPages = [
    {
        path: '/404',
        exact: true,
        name: 'page-not-found',
        component: () => <PageNotFound />,
    },
];